module.exports = __webpack_public_path__ + "media/images/flags/4x3/guy-e948cf4f9aea5db2ef970cc8dfc49a8a.svg";